module.exports = __webpack_public_path__ + "assets/img/8_1707_big.99e6ba41.jpg";